import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { FlexContainer, Search, SortBy } from 'components/common';
import { Filters, FiltersActive } from 'components/common/filter';

interface Props {
  defaultSort: string;
  includeFilters?: boolean;
}

const MyTeamReviewFilters = ({ defaultSort, includeFilters }: Props) => {
  const { messages } = useReduxState();

  const router = useRouter();

  const sortOptions = [
    { text: defaultSort, value: 'date' },
    { text: messages.commonName, value: 'name' }
  ];

  return (
    <FlexContainer
      style={{
        alignItems: 'flex-start',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <FlexContainer
        style={{
          flexWrap: 'wrap',
          gap: 10,
          justifyContent: 'space-between',
          width: '100%'
        }}
      >
        <FlexContainer style={{ gap: 10, flexWrap: 'wrap' }}>
          <div style={{ width: 250 }}>
            <Search
              placeholder={messages.usersSearchUsers}
              size="header"
              withUrl={true}
            />
          </div>

          {includeFilters ? (
            <Filters
              filters={{}}
              customFilters={[
                {
                  field: 'isHidden',
                  icon: 'eye-slash',
                  items: [
                    {
                      label: messages.myTeamReviewFiltersHiddenCompletionsValue,
                      value: 'true'
                    }
                  ],
                  position: 0,
                  title: messages.myTeamReviewFiltersHiddenCompletions
                }
              ]}
              filterId="completions"
            />
          ) : null}
        </FlexContainer>

        <SortBy
          options={sortOptions}
          withUrl={true}
          value={(router.query.sortBy || 'date') as string}
        />
      </FlexContainer>

      {includeFilters ? <FiltersActive filterId="completions" /> : null}
    </FlexContainer>
  );
};

export default MyTeamReviewFilters;
